import { render, staticRenderFns } from "./OctRadio.vue?vue&type=template&id=02727310&scoped=true&"
import script from "./OctRadio.vue?vue&type=script&lang=js&"
export * from "./OctRadio.vue?vue&type=script&lang=js&"
import style0 from "./OctRadio.vue?vue&type=style&index=0&id=02727310&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02727310",
  null
  
)

export default component.exports